class Floor {
  constructor(data) {
    this.map = data.map; // Svg map
    this.backgroundImage = String(data.backgroundImage); // Url to the background-image.
    this.level = Number(data.level); // Number (-Infinity, Infinity).
  }
}

export default Floor;
